import moment from "moment";
import { getAppointmentPhase, getTrainTravelClass } from "../enumutils";
import { GooglePlaceState } from "./groundFields";

export interface NewTrainFormState {
  artist: server.dto.ArtistSmall | undefined
  phase: server.dto.AppointmentPhase
  travellers: server.dto.ContactSmallV2[]

  bookingReference: string
  travelAgency: string
  notes: string
  trainNumber: string
  carriage: string
  seat: string
  travelClass: server.dto.TrainTravelClass | undefined

  departureStation: GooglePlaceState | undefined
  departureDate: moment.Moment
  departurePlatform: string

  arrivalStation: GooglePlaceState | undefined
  arrivalDate: moment.Moment
  arrivalPlatform: string
}

export const getInitialNewTrainFormState = (
    serverReference: server.dto.ServerReference,
    fromTrain: server.dto.TrainSidePanelData | undefined,
    artist: server.dto.ArtistSmall | undefined,
    date: moment.Moment | undefined,
): NewTrainFormState => {
  const previousLegDate = fromTrain?.train.dateTime.endDisplay
    ? moment.utc(fromTrain.train.dateTime.endDisplay)
    : (date ?? moment.utc());

  return {
    artist: fromTrain?.train.artist ?? artist,
    phase: getAppointmentPhase(fromTrain?.train.phase ?? "confirmed", serverReference),
    travellers: fromTrain?.passengers ?? [],

    bookingReference: fromTrain?.train.bookingReference ?? "",
    travelAgency: fromTrain?.train.travelAgency ?? "",
    notes: fromTrain?.train.notes ?? "",
    trainNumber: "",
    carriage: "",
    seat: "",
    travelClass: fromTrain?.train.travelClass ? getTrainTravelClass(fromTrain.train.travelClass, serverReference) : undefined,

    departureStation: fromTrain?.train.arrival ? {
      googlePlaceId: fromTrain.train.arrival.googlePlaceId,
      placeIdentifier: fromTrain.train.arrival.placeIdentifier,
      name: fromTrain.train.arrival.name,
      address: fromTrain.train.arrival.address.formatted.join(", "),
      geo: fromTrain.train.arrival.latLng,
    } : undefined,
    departureDate: previousLegDate.clone(),
    departurePlatform: fromTrain?.train.arrivalPlatform ?? "",

    arrivalStation: undefined,
    arrivalDate: previousLegDate.clone(),
    arrivalPlatform: "",
  };
};

// Return type is inferred: the generated CreateTrainInstruction types artistId and the
// station ids as non-null, but the code passes null / undefined for them.
export const getCreateTrainInstruction = (
    state: NewTrainFormState,
    linkToShowId: number | undefined,
) => ({
  arrivalGooglePlaceId: state.arrivalStation?.googlePlaceId,
  arrivalLocal: state.arrivalDate.toDate(),
  arrivalPlatform: state.arrivalPlatform,
  artistId: state.artist?.artistId || null,
  bookingReference: state.bookingReference,
  carriage: state.carriage,
  departureGooglePlaceId: state.departureStation?.googlePlaceId,
  departureLocal: state.departureDate.toDate(),
  departurePlatform: state.departurePlatform,
  linkToShowId,
  notes: state.notes,
  passengers: state.travellers.map(t => t.contactId),
  phase: state.phase.value,
  seats: state.seat,
  trainNumber: state.trainNumber,
  travelAgency: state.travelAgency,
  travelClass: state.travelClass?.value ?? "unknown",
});
